import { Heart, Mail, Phone, MapPin, Linkedin, Instagram, Facebook, Youtube } from 'lucide-react';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-secondary-900 text-secondary-300 py-12">
      <div className="container mx-auto px-4">
        <div className="grid md:grid-cols-3 gap-8 mb-8">
          {/* À propos */}
          <div>
            <div className="flex items-center gap-3 mb-4">
              <img src="/logo-color.svg" alt="Patrick Sanchez Logo" className="h-12 w-12" />
              <h3 className="text-white font-bold text-lg">Patrick Sanchez</h3>
            </div>
            <p className="text-sm text-secondary-400 mb-2">
              SIRET : 798 419 248 00025
            </p>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-white font-bold text-lg mb-4">Contact</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <a href="mailto:contact@patrick-sanchez.fr" className="hover:text-white transition flex items-center gap-2">
                  <Mail size={16} />
                  contact@patrick-sanchez.fr
                </a>
              </li>
              <li>
                <a href="tel:0688761312" className="hover:text-white transition flex items-center gap-2">
                  <Phone size={16} />
                  06 88 76 13 12
                </a>
              </li>
              <li className="flex items-start gap-2">
                <MapPin size={16} className="mt-0.5 flex-shrink-0" />
                <span>61 rue de Lyon<br />75012 Paris</span>
              </li>
            </ul>
          </div>

          {/* Liens */}
          <div>
            <h3 className="text-white font-bold text-lg mb-4">Suivez-moi</h3>
            <div className="flex flex-wrap gap-3">
              <a
                href="https://www.linkedin.com/in/sanchez-patrick/"
                target="_blank"
                rel="noopener noreferrer"
                className="p-2 bg-secondary-800 rounded-lg hover:bg-primary-500 transition"
                title="LinkedIn"
              >
                <Linkedin size={20} />
              </a>
              <a
                href="https://www.instagram.com/super_sancho45/"
                target="_blank"
                rel="noopener noreferrer"
                className="p-2 bg-secondary-800 rounded-lg hover:bg-primary-500 transition"
                title="Instagram"
              >
                <Instagram size={20} />
              </a>
              <a
                href="https://www.facebook.com/profile.php?id=61575714210044"
                target="_blank"
                rel="noopener noreferrer"
                className="p-2 bg-secondary-800 rounded-lg hover:bg-primary-500 transition"
                title="Facebook"
              >
                <Facebook size={20} />
              </a>
              <a
                href="https://www.youtube.com/@super_sancho"
                target="_blank"
                rel="noopener noreferrer"
                className="p-2 bg-secondary-800 rounded-lg hover:bg-primary-500 transition"
                title="YouTube"
              >
                <Youtube size={20} />
              </a>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t border-secondary-800 pt-8 text-center text-sm">
          <p className="flex items-center justify-center gap-2 mb-4">
            Fait avec <Heart size={16} className="text-red-500 fill-current" /> par Patrick Sanchez
            © {currentYear}
          </p>
          <p>
            <a
              href="https://www.patrick-sanchez.fr/conditions-generales-de-vente/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-secondary-400 hover:text-white transition underline"
            >
              Conditions Générales de Vente
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}
